import React from 'react'

import { MemberRole } from 'features/team/model/types/members'
import { hasAccess } from 'shared/utils/access'
import styled from 'styled-components'

interface EmptyBoardPlaceholderProps {
    className?: string,
    texts: {
        title: string,
        description: string,
        uploadBtn?: string
    },
    onUploadFiles?: (files: FileList) => void,
    isNotFoundPlaceholder?: boolean,
    isFolderImage?: boolean,
  inputRef?: React.RefObject<HTMLInputElement>,
  userRole: MemberRole,
}

export const EmptyBoardPlaceholder: React.FC<EmptyBoardPlaceholderProps> = ({
  className = '',
  texts,
  onUploadFiles,
  inputRef,
  userRole,
}) => {
  const handleUploadFiles = (e) => {
    onUploadFiles(e.target.files)
  }

  return (
    <EmptyFolderPlaceholderBox
      className={className}
    >

      <ContainerImg src="/assets/placeholders-images/no-content.svg" />

      <EmptyTitle>
        {texts.title}
      </EmptyTitle>

      <EmptyText>
        {texts.description}
      </EmptyText>

      {!!texts.uploadBtn && hasAccess(userRole, [MemberRole.ADMIN, MemberRole.OWNER, MemberRole.USER]) && (
        <StyledSecondaryButton
          htmlFor="files-upload"
        >
          {texts.uploadBtn}

          <HiddenFilesInput
            ref={inputRef}
            id="files-upload"
            onChange={handleUploadFiles}
            type="file"
            multiple
            accept="*"
          />
        </StyledSecondaryButton>
      )}
    </EmptyFolderPlaceholderBox>
  )
}

const EmptyFolderPlaceholderBox = styled.div`
  display: flex;
  flex-flow: column;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 400px);
  padding: 40px 20px;
`

const ContainerImg = styled.img`
  width: 203px;
  height: 182px;
  display: block;
  pointer-events: none;
`

const EmptyTitle = styled.h2`
  margin: 40px 0 0 0;
  font-size: 24px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
  font-weight: 500;
`

const EmptyText = styled.p`
  margin-top: 24px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #00000068;
  max-width: 480px;
`

const StyledSecondaryButton = styled.label`
  margin-top: 24px;
  background: transparent;
  border: 1px solid #D9D9D9;
  border-radius: 8px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
  padding: 12px 24px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f2f2f2;
  }
`

const HiddenFilesInput = styled.input`
  display: none;
`
